import { BookOpen, GraduationCap, Network, Map, Layers, School } from 'lucide-react';
import type { GradeTab, AnalysisLevel, MetricMode, GroupDef } from './types';
import React from 'react';

export const GRADE_TABS: { id: GradeTab; label: string; icon: React.FC<{ className?: string }> }[] = [
  { id: 'class10', label: 'Class 10', icon: BookOpen },
  { id: 'class12', label: 'Class 12', icon: GraduationCap },
];

export const ANALYSIS_LEVELS: { id: AnalysisLevel; label: string; icon: React.FC<{ className?: string }> }[] = [
  { id: 'RO', label: 'Region', icon: Network },
  { id: 'STATE', label: 'State', icon: Map },
  { id: 'DISTRICT', label: 'District', icon: Layers },
  { id: 'KV', label: 'KV', icon: School },
];

export const METRIC_MODES: { id: MetricMode; label: string }[] = [
  { id: 'passStats', label: 'Pass Stats' },
  { id: 'pi', label: 'Performance Index' },
  { id: 'overall', label: 'Overall' },
];

export const BASE_GROUPS: GroupDef[] = [
  { id: 'overall', label: 'Overall', segments: [] },
  {
    id: 'gender', label: 'Gender',
    segments: [{ value: 'male', label: 'Boys' }, { value: 'female', label: 'Girls' }],
  },
  {
    id: 'socialcategory', label: 'Social Category',
    segments: [
      { value: 'general', label: 'General' },
      { value: 'obc', label: 'OBC' },
      { value: 'sc', label: 'SC' },
      { value: 'st', label: 'ST' },
    ],
  },
  {
    id: 'location', label: 'Location',
    segments: [{ value: 'urban', label: 'Urban' }, { value: 'rural', label: 'Rural' }],
  },
  {
    id: 'cwsn', label: 'CWSN',
    segments: [{ value: 'cwsn', label: 'CWSN' }],
  },
  {
    id: 'pmshri', label: 'PM SHRI',
    segments: [{ value: 'pmshri', label: 'PM SHRI' }, { value: 'nonpmshri', label: 'Non-PM SHRI' }],
  },
  // 'Sector' used to sit alongside this and filtered the very same DB column
  // with the same values — the only difference was that it offered 'Foreign'.
  // That segment moved here and the duplicate group was removed.
  {
    id: 'sponsoredby', label: 'Sponsored By',
    segments: [
      { value: 'civil', label: 'Civil' },
      { value: 'defence', label: 'Defence' },
      { value: 'project', label: 'Project' },
      { value: 'ihl', label: 'IHL' },
      { value: 'foreign', label: 'Foreign' },
    ],
  },
];

export const STREAM_GROUP: GroupDef = {
  id: 'stream', label: 'Stream',
  segments: [
    { value: 'science', label: 'Science' },
    { value: 'commerce', label: 'Commerce' },
    { value: 'arts', label: 'Arts / Humanities' },
    // Vocational runs in only a few regions and only in some sessions, so it is
    // shown only where the region/year actually reports it — see
    // STREAM_SEGMENT_BY_DB_VALUE and its use in RegionDrillDown.
    { value: 'vocational', label: 'Vocational' },
  ],
};

/** Maps the DB "STREAM" value to the segment value used by the filters. */
export const STREAM_SEGMENT_BY_DB_VALUE: Record<string, string> = {
  SCIENCE: 'science',
  COMMERCE: 'commerce',
  HUMANITIES: 'arts',
  VOCATIONAL: 'vocational',
};

export const CHART_COLORS = ['#F36B21', '#3b82f6', '#22c55e', '#8b5cf6', '#ec4899', '#f59e0b', '#06b6d4', '#ef4444'];
export const CHART_COLORS_EXT = [
  '#F36B21', '#3b82f6', '#22c55e', '#8b5cf6', '#ec4899', '#f59e0b',
  '#06b6d4', '#ef4444', '#14b8a6', '#a855f7', '#fb923c', '#84cc16',
];

export const YEARS = [2025, 2024, 2023, 2022];
